import { Component, Inject, OnInit } from '@angular/core';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataTableEvent } from '../../../../components/data-table/data-table.component';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';

@Component({
    selector: 'app-dynamic-content-entrance-selection',
    templateUrl: './dynamic-content-entrance-selection.component.html',
    styleUrls: ['./dynamic-content-entrance-selection.component.scss'],
    providers: [DynamicContentEntranceService, PackageInstalledAppsService],
    standalone: false
})
export class DynamicContentEntranceSelectionComponent implements OnInit {

  public columns = [
    { prop: 'title' }, { prop: '_id' },
    { validate: '_id', name: 'Assigned', icon: 'check_box' }
  ];
  public params;
  public tableData;

  constructor(
    private dialogRef: MatDialogRef<DynamicContentEntranceSelectionComponent>, private packageInstalledAppsService: PackageInstalledAppsService,
    private dynamicContentEntranceService: DynamicContentEntranceService, @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  async ngOnInit() {
    this.params = { OwnerOrganisationID: { $in: this.data.organisationIds } };
    const entrances = await this.dynamicContentEntranceService.find(0, 100, { OwnerOrganisationID: { $in: this.data.organisationIds } });
    const ids = entrances.data.map(entrance => entrance._id);
    const apps = await this.packageInstalledAppsService.find(0, 100, { dynamicContentEntranceId: { $in: ids } });
    entrances.data.map(item => {
      const app = apps.data.find(el => el.dynamicContentEntranceId === item._id);
      if (app?.translations && app.translations.find(translation => translation.language === 'de')) {
        item['title'] = app.translations.find(translation => translation.language === 'de').appTitle;
      }
    });
    this.tableData = entrances.data;
  }

  onSelect(event: DataTableEvent) {
    let data = null;
    if (!event.row.isValidated) {
      data = event.row;
    }
    this.dialogRef.close(data);
  }

  abort() {
    this.dialogRef.close();
  }

}
